import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface Member{
    id?: number;
    first_name?: string;
    last_name?: string;
    ssn?: string;
    ownership?: string;
    address_1?: string;
    address_2?: string;
    country?: string;
    state?: string;
    city?: string;
    zip_code?: string;
    country_code?: string;
    contact?: string;
    attachment?: string;
    status?: number
    passport_number?: string
    company?: number;
    us_resident?: boolean;
}

export const memberApi = createApi({
    reducerPath: "memberApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getMember: builder.query<Member[], number>({
            query: (companyId) => `/client-member/${companyId}`
        })
    })
})

export const { useGetMemberQuery } = memberApi